export default __webpack_public_path__ + "static/media/logo.480cc8ea.png";